// React
import React from "react";
import PropTypes from "prop-types";
// i18n
import { withNamespaces } from "react-i18next";

function SelectExamParts({ checkOption, item, remainingAvailableTime, t }) {
  const { examinationParts } = item;
  const isDisabled = (part) =>
    remainingAvailableTime < parseInt(part.examDuration, 10) && !part.checked;

  return !examinationParts ? null : (
    <div className="col-12 smart-form">
      {examinationParts.map((part) => (
        <label className={`checkbox ${isDisabled(part) && "state-disabled"}`} key={part.examPartId}>
          <input
            type="checkbox"
            className="checkbox style-0"
            disabled={isDisabled(part)}
            onChange={checkOption(part.examPartId)}
          />
          <i />
          <span>
            {t("modules.localization.register.authenticated.exams.examDuration", {
              name: part.examName,
              duration: part.examDuration
            })}
          </span>
        </label>
      ))}
      <div>
        <p>
          <b>
            {t("modules.localization.register.authenticated.exams.remainingAvailableTime", {
              time: remainingAvailableTime
            })}
          </b>
        </p>
      </div>
    </div>
  );
}

SelectExamParts.propTypes = {
  checkOption: PropTypes.func.isRequired,
  item: PropTypes.object,
  remainingAvailableTime: PropTypes.number,
  t: PropTypes.func.isRequired
};

export default withNamespaces()(SelectExamParts);
